import { useState } from 'react';
import { Buttons, ChooseAudienceModal } from 'components';

const ChooseAudienceBtn = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Buttons.SecondaryNormal
        id='audience-btn'
        style={{ width: '100%' }}
        onClick={() => setIsOpen(true)}
      >
        Manage Audience
      </Buttons.SecondaryNormal>
      {isOpen && <ChooseAudienceModal handleCloseWindow={() => setIsOpen(false)} />}
    </>
  );
};
export default ChooseAudienceBtn;
